import { Application } from "@hotwired/stimulus"
import 'flowbite'
import 'bootstrap'

const application = Application.start()

// Vite replacement for webpack's require.context() — eager-load every
// *_controller.js under ./controllers and register it with Stimulus.
const controllers = import.meta.glob('./controllers/**/*_controller.js', { eager: true })
Object.entries(controllers).forEach(([path, mod]) => {
  const name = path
    .replace('./controllers/', '')
    .replace(/_controller\.js$/, '')
    .replace(/\//g, '--')
  application.register(name, mod.default)
})

// load Turbolinks
import Turbolinks from "turbolinks"
Turbolinks.start()

// load flashes with toastr gem
import './toastr'

// load jQuery — the legacy 1.12 UMD file self-registers `window.jQuery`
// via its browser branch, so import for side effects and read back from
// the global. The namespace-import + default-fallback pattern was
// overwriting the real jQuery function with an empty `[object Module]`
// when Vite's CJS interop did not produce a default export from the
// UMD file.
import 'jquery'
const jQuery = window.jQuery
window.$ = jQuery

// cookieconsent self-registers `window.cookieconsent` for the inline
// `cookieconsent.initialise(...)` call in `v2/application.html.erb`.
// Under Webpacker this was missing in the v2 pack too — the layout's
// inline script always failed silently. Vite module scripts surface
// the same TypeError visibly in the console.
import '../../customer_side/Javascripts/libraries/cookieconsent'

// load address validation modules
import '../../customer_side/Javascripts/custom_modules/address_validation'
import '../../customer_side/Javascripts/user_edit'

// load custom scripts
import './enable_submit_button'
import './handle_dropdowns'
import './handle_trustpilot_widget'
